var components
try {
  components = {
    zPaging: function () {
      return import(
        /* webpackChunkName: "uni_modules/z-paging/components/z-paging/z-paging" */ "@/uni_modules/z-paging/components/z-paging/z-paging.vue"
      )
    },
    uTabsSwiper: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-tabs-swiper/u-tabs-swiper" */ "uview-ui/components/u-tabs-swiper/u-tabs-swiper.vue"
      )
    },
    uImage: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-image/u-image" */ "uview-ui/components/u-image/u-image.vue"
      )
    },
    uToast: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-toast/u-toast" */ "uview-ui/components/u-toast/u-toast.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.courseList, function (item, __i0__) {
    var $orig = _vm.__get_orig(item)
    var g0 = item.courseInfo.videos ? item.courseInfo.videos.length : null
    return {
      $orig: $orig,
      g0: g0,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }